var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-white"},[_c('h3',{staticClass:"text-white"},[_vm._v("O prazo para cadastros expirou.")])])}]

export { render, staticRenderFns }